// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-list {    
    display: grid;
    grid-template-columns: repeat(11, 1fr);
    grid-gap: var(--space-and-half);
    gap: var(--space-and-half);
    height: 100%;
    background: var(--new-background-color);
    /* box-shadow: 0px 5px 0px rgba(192, 208, 214, 0.33) inset; */
}
.settings-list__content {
    grid-column-start: 1;
    grid-column-end: 3;
    background: var(--white-color);
    height: 130vh;
    /* width: calc(calc(100% /12) * 2); */
    width: 100%;
    /* position: fixed; */
    padding: 16px;
    border-right: 1px solid var(--new-gray-background-color);
}
.settings-list__content__title {
    margin-bottom: 24px;
}

.settings-list__content__title__text.baloa-headline-2{
    color: var(--primary-very-dark-color);
}
.settings-list__content__field {   
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 4px;
    padding: 10px;
    margin-bottom: 12px;
}

.settings-list__content__field .icon {
    font-size: 24px;
    margin-right: 10px;
}

.settings-list__content__field .hubicon-person::before {
    color: unset;
}

.settings-list__content__line {
    border-top: 1px solid var(--primary-light-color);
    padding: 0;
    margin: 0 auto 0 auto;
  }
.settings-list__content__field:hover, .settings-list__content__field:hover .settings-list__content__field__data__text.baloa-normal-medium {
    background-color: var(--new-green-color);
    color: var(--white-color);
}
.settings-list__content__field.active, .settings-list__content__field.active .settings-list__content__field__data__text.baloa-normal-medium {
    background-color: var(--new-green-color);
    color: var(--white-color);
}

.settings-list__content__field__data {
    padding-left: var(--space-x2);
    display: flex;
    max-height: var(--space-x3);
    min-height: var(--space-x3);
    align-items: center;
}
.settings-list__content__field__data__text.baloa-normal-medium{
    color: var(--primary-dark-color);
}
/* .settings-list__content__field__data__text.baloa-normal-medium:hover{
    color: var(--white-color);
}
.settings-list__content__field__data__text.baloa-normal-medium:active{
    color: var(--white-color);
} */

/* .settings-list__content__field__icon-chevron {
    font-size: var(--space-and-half);
} */
.settings-list__content__button {
    margin-top: var(--space-x2);
    cursor: pointer;
    width: 30%;
}

.settings-list__content__button__text{
    font-family: var(--secondary-font) !important;
    font-style: normal;
    font-weight: var(--font-bold) !important;
    font-size: 12px !important;
    line-height: var(--space-and-half) !important;
    letter-spacing: 0.04em !important;
    color: var(--primary-very-dark-color) !important;
}

.settings-list__settings {
    grid-column-start: 4;
    grid-column-end: 11;
}

.settings-list__settings.fullwidth {
    grid-column-start: 3;
    grid-column-end: 12;
}

.settings__content {
    margin-top: 27px;
    border-radius: 12px;
    background: var(--white-color);
}

.settings__content.fullwidth {
    position: relative;
    margin-top: 0;
    border-radius: 0;
    left: calc(var(--space-and-half)* -1);
    width: calc(100% + var(--space-and-half));
    background: none;
}

.settings__content__title__text{
    padding-top: calc(var(--space) + var(--space-quarter));
    padding-bottom: calc(var(--space) + var(--space-quarter));
    padding-left: calc(var(--space) + var(--space-quarter));
}
.settings__content__title__text.baloa-subtitle-2{
    color: var(--primary-very-dark-color);
}
.MuiFormControl-root.settings__content__language__radiobuttons{
    margin-top: 28px; 
    margin-left: var(--space-x2); 
    margin-bottom: 28px;  
}
.settings__content__language__radiobuttons .MuiFormControlLabel-root.baloa-names .MuiTypography-body1{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc(var(--space) + 1px);/*17px*/
    line-height: calc(var(--space) + var(--space-quarter));/* 20px */
    letter-spacing: 0.005em;
    color: var(--basic-gray-color);
}
.settings__separator{
    border-top: 1px solid var(--separator-color);
}

/* .settings__content .edit-content{
    background: var(--white-color);
    border-radius: 8px;
}

.settings__content__title{
    background: var(--white-color);
}
 */
.settings__content__payments__center-container-text {
    background: var(--white-color);
    margin: 25px;
    padding: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.settings__content__payments__center-container-img{
    text-align: center;
    padding-top: 70px;
}

.settings__content__payments__center-container-img img{
    height: 350px;
}

.settings__content__payments__center-container__action-box .hubicon-info::before {
    color: var(--new-green-color);
    margin-right: 14px;
    font-size: 20px;
}

.settings__content__payments__center-container__action-box .hubicon-info.error::before  {
    color: var(--error-color);
    margin-right: 14px;
    font-size: 38px;
}

.settings__content__payments__center-container__action-box .baloa-normal-text{
    font-weight: var(--font-medium);
    display: flex;
    align-items: center;
    padding-bottom: var(--space-and-half);
    color: var(--primary-very-dark-color);
}

.settings__content__payments__center-container__action-box .baloa-names{
    color: var(--primary-dark-color);
    font-weight: var(--font-regular);
    padding-right: 40px;
    padding-top: 8px;
}

.settings__content .settings__content__payments__center-container{
    background: var(--new-background-color);
}

.settings__content__payments__center-container__action-box{
    background-color: var(--white-color);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 16px;
}


@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .settings-list {
        display: block;
    } 
    .settings__content {
        margin: 16px;
    }
    .user-settings__mobile-menu__container {
        background-color: var(--white-color);
        padding: 8px 12px;
        border-top: 2px solid var(--new-background-color);
    }
    .user-settings__mobile-menu__container .baloa-names {
        font-size: 18px;
        line-height: 21px;
        color: var(--new-text-link-color);
        margin-bottom: var(--space);
    }
    .user-settings__mobile-menu__actions {
        display: flex;
        justify-content: flex-start;
    }
    .user-settings__mobile-menu__actions .baloa-table-column {
        font-size: 12px;
        line-height: 14px;
        color: var(--primary-dark-color);
        padding: var(--space-half);
    }
    .user-settings__mobile-menu__actions .baloa-table-column.active {
        background-color: rgba(48, 179, 107, 0.2);
        border-radius: 16px;
        color: var(--new-green-color);
    }
    .settings__separator{
        border-top: none;
    }
    .MuiFormControl-root.settings__content__language__radiobuttons{
        margin-left: calc(var(--space) + var(--space-quarter));
        margin-top: 0;
    }

    .settings__content__payments__center-container-img img{
        height: 135px;
    }

    .settings__content__payments__center-container__action-box{
        display: grid;
        align-items: center;
        justify-items: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/user-settings/views/UserSettingsView.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sCAAsC;IACtC,+BAA+B;IAC/B,0BAA0B;IAC1B,YAAY;IACZ,uCAAuC;IACvC,6DAA6D;AACjE;AACA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,8BAA8B;IAC9B,aAAa;IACb,qCAAqC;IACrC,WAAW;IACX,qBAAqB;IACrB,aAAa;IACb,wDAAwD;AAC5D;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;AACzC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gDAAgD;IAChD,UAAU;IACV,qBAAqB;EACvB;AACF;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;AACA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,2BAA2B;IAC3B,2BAA2B;IAC3B,mBAAmB;AACvB;AACA;IACI,gCAAgC;AACpC;AACA;;;;;GAKG;;AAEH;;GAEG;AACH;IACI,2BAA2B;IAC3B,eAAe;IACf,UAAU;AACd;;AAEA;IACI,6CAA6C;IAC7C,kBAAkB;IAClB,wCAAwC;IACxC,0BAA0B;IAC1B,6CAA6C;IAC7C,iCAAiC;IACjC,gDAAgD;AACpD;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,qCAAqC;IACrC,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;IACI,sDAAsD;IACtD,yDAAyD;IACzD,uDAAuD;AAC3D;AACA;IACI,qCAAqC;AACzC;AACA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;AACvB;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,mCAAmC,CAAC,OAAO;IAC3C,sDAAsD,CAAC,SAAS;IAChE,uBAAuB;IACvB,8BAA8B;AAClC;AACA;IACI,4CAA4C;AAChD;;AAEA;;;;;;;;EAQE;AACF;IACI,8BAA8B;IAC9B,YAAY;IACZ,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;;AAGA,yCAAyC,4BAA4B;IACjE;QACI,cAAc;IAClB;IACA;QACI,YAAY;IAChB;IACA;QACI,oCAAoC;QACpC,iBAAiB;QACjB,iDAAiD;IACrD;IACA;QACI,eAAe;QACf,iBAAiB;QACjB,iCAAiC;QACjC,2BAA2B;IAC/B;IACA;QACI,aAAa;QACb,2BAA2B;IAC/B;IACA;QACI,eAAe;QACf,iBAAiB;QACjB,gCAAgC;QAChC,0BAA0B;IAC9B;IACA;QACI,yCAAyC;QACzC,mBAAmB;QACnB,6BAA6B;IACjC;IACA;QACI,gBAAgB;IACpB;IACA;QACI,sDAAsD;QACtD,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,qBAAqB;IACzB;AACJ","sourcesContent":[".settings-list {    \n    display: grid;\n    grid-template-columns: repeat(11, 1fr);\n    grid-gap: var(--space-and-half);\n    gap: var(--space-and-half);\n    height: 100%;\n    background: var(--new-background-color);\n    /* box-shadow: 0px 5px 0px rgba(192, 208, 214, 0.33) inset; */\n}\n.settings-list__content {\n    grid-column-start: 1;\n    grid-column-end: 3;\n    background: var(--white-color);\n    height: 130vh;\n    /* width: calc(calc(100% /12) * 2); */\n    width: 100%;\n    /* position: fixed; */\n    padding: 16px;\n    border-right: 1px solid var(--new-gray-background-color);\n}\n.settings-list__content__title {\n    margin-bottom: 24px;\n}\n\n.settings-list__content__title__text.baloa-headline-2{\n    color: var(--primary-very-dark-color);\n}\n.settings-list__content__field {   \n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    border-radius: 4px;\n    padding: 10px;\n    margin-bottom: 12px;\n}\n\n.settings-list__content__field .icon {\n    font-size: 24px;\n    margin-right: 10px;\n}\n\n.settings-list__content__field .hubicon-person::before {\n    color: unset;\n}\n\n.settings-list__content__line {\n    border-top: 1px solid var(--primary-light-color);\n    padding: 0;\n    margin: 0 auto 0 auto;\n  }\n.settings-list__content__field:hover, .settings-list__content__field:hover .settings-list__content__field__data__text.baloa-normal-medium {\n    background-color: var(--new-green-color);\n    color: var(--white-color);\n}\n.settings-list__content__field.active, .settings-list__content__field.active .settings-list__content__field__data__text.baloa-normal-medium {\n    background-color: var(--new-green-color);\n    color: var(--white-color);\n}\n\n.settings-list__content__field__data {\n    padding-left: var(--space-x2);\n    display: flex;\n    max-height: var(--space-x3);\n    min-height: var(--space-x3);\n    align-items: center;\n}\n.settings-list__content__field__data__text.baloa-normal-medium{\n    color: var(--primary-dark-color);\n}\n/* .settings-list__content__field__data__text.baloa-normal-medium:hover{\n    color: var(--white-color);\n}\n.settings-list__content__field__data__text.baloa-normal-medium:active{\n    color: var(--white-color);\n} */\n\n/* .settings-list__content__field__icon-chevron {\n    font-size: var(--space-and-half);\n} */\n.settings-list__content__button {\n    margin-top: var(--space-x2);\n    cursor: pointer;\n    width: 30%;\n}\n\n.settings-list__content__button__text{\n    font-family: var(--secondary-font) !important;\n    font-style: normal;\n    font-weight: var(--font-bold) !important;\n    font-size: 12px !important;\n    line-height: var(--space-and-half) !important;\n    letter-spacing: 0.04em !important;\n    color: var(--primary-very-dark-color) !important;\n}\n\n.settings-list__settings {\n    grid-column-start: 4;\n    grid-column-end: 11;\n}\n\n.settings-list__settings.fullwidth {\n    grid-column-start: 3;\n    grid-column-end: 12;\n}\n\n.settings__content {\n    margin-top: 27px;\n    border-radius: 12px;\n    background: var(--white-color);\n}\n\n.settings__content.fullwidth {\n    position: relative;\n    margin-top: 0;\n    border-radius: 0;\n    left: calc(var(--space-and-half)* -1);\n    width: calc(100% + var(--space-and-half));\n    background: none;\n}\n\n.settings__content__title__text{\n    padding-top: calc(var(--space) + var(--space-quarter));\n    padding-bottom: calc(var(--space) + var(--space-quarter));\n    padding-left: calc(var(--space) + var(--space-quarter));\n}\n.settings__content__title__text.baloa-subtitle-2{\n    color: var(--primary-very-dark-color);\n}\n.MuiFormControl-root.settings__content__language__radiobuttons{\n    margin-top: 28px; \n    margin-left: var(--space-x2); \n    margin-bottom: 28px;  \n}\n.settings__content__language__radiobuttons .MuiFormControlLabel-root.baloa-names .MuiTypography-body1{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc(var(--space) + 1px);/*17px*/\n    line-height: calc(var(--space) + var(--space-quarter));/* 20px */\n    letter-spacing: 0.005em;\n    color: var(--basic-gray-color);\n}\n.settings__separator{\n    border-top: 1px solid var(--separator-color);\n}\n\n/* .settings__content .edit-content{\n    background: var(--white-color);\n    border-radius: 8px;\n}\n\n.settings__content__title{\n    background: var(--white-color);\n}\n */\n.settings__content__payments__center-container-text {\n    background: var(--white-color);\n    margin: 25px;\n    padding: 32px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.settings__content__payments__center-container-img{\n    text-align: center;\n    padding-top: 70px;\n}\n\n.settings__content__payments__center-container-img img{\n    height: 350px;\n}\n\n.settings__content__payments__center-container__action-box .hubicon-info::before {\n    color: var(--new-green-color);\n    margin-right: 14px;\n    font-size: 20px;\n}\n\n.settings__content__payments__center-container__action-box .hubicon-info.error::before  {\n    color: var(--error-color);\n    margin-right: 14px;\n    font-size: 38px;\n}\n\n.settings__content__payments__center-container__action-box .baloa-normal-text{\n    font-weight: var(--font-medium);\n    display: flex;\n    align-items: center;\n    padding-bottom: var(--space-and-half);\n    color: var(--primary-very-dark-color);\n}\n\n.settings__content__payments__center-container__action-box .baloa-names{\n    color: var(--primary-dark-color);\n    font-weight: var(--font-regular);\n    padding-right: 40px;\n    padding-top: 8px;\n}\n\n.settings__content .settings__content__payments__center-container{\n    background: var(--new-background-color);\n}\n\n.settings__content__payments__center-container__action-box{\n    background-color: var(--white-color);\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 24px 16px;\n}\n\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .settings-list {\n        display: block;\n    } \n    .settings__content {\n        margin: 16px;\n    }\n    .user-settings__mobile-menu__container {\n        background-color: var(--white-color);\n        padding: 8px 12px;\n        border-top: 2px solid var(--new-background-color);\n    }\n    .user-settings__mobile-menu__container .baloa-names {\n        font-size: 18px;\n        line-height: 21px;\n        color: var(--new-text-link-color);\n        margin-bottom: var(--space);\n    }\n    .user-settings__mobile-menu__actions {\n        display: flex;\n        justify-content: flex-start;\n    }\n    .user-settings__mobile-menu__actions .baloa-table-column {\n        font-size: 12px;\n        line-height: 14px;\n        color: var(--primary-dark-color);\n        padding: var(--space-half);\n    }\n    .user-settings__mobile-menu__actions .baloa-table-column.active {\n        background-color: rgba(48, 179, 107, 0.2);\n        border-radius: 16px;\n        color: var(--new-green-color);\n    }\n    .settings__separator{\n        border-top: none;\n    }\n    .MuiFormControl-root.settings__content__language__radiobuttons{\n        margin-left: calc(var(--space) + var(--space-quarter));\n        margin-top: 0;\n    }\n\n    .settings__content__payments__center-container-img img{\n        height: 135px;\n    }\n\n    .settings__content__payments__center-container__action-box{\n        display: grid;\n        align-items: center;\n        justify-items: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
